import { Box, Grid2 } from '@mui/material';
import CustomTypography from '@qler-view/shared_lib/src/shared/lib/ui-components/Typography/CustomTypography';
import NoDataMessage from '../components/NoDataMessage';
import ConsultCard from './consultcard';
import { type ConsultsResponse } from '../../API/services/consultsService';

type ConsultListProps = {
  consults: ConsultsResponse[];
  emptyMessage: string;
  loading?: boolean;
  pastConsult?: boolean;
  onAccept?: (userId: number, caseId: number) => void;
  assigned?: boolean;
  isAssigned?: boolean;
};

const ConsultListRender = ({
  consults,
  emptyMessage,
  loading = false,
  pastConsult = false,
  onAccept,
  assigned = false,
  isAssigned = false,
}: ConsultListProps) => {
  const userId = Number.parseInt(localStorage.getItem('userId') ?? '0');

  if (loading) {
    return (
      <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 4 }} className="button-width">
        <Box className="text-align-center no-consults-data">
          <CustomTypography id="loading-text" variant="h5" color="textDisabled">
            Loading...
          </CustomTypography>
        </Box>
      </Grid2>
    );
  }

  return (
    <>
      {consults.length > 0 ? (
        consults.map((consult) => (
          <Grid2
            key={consult.consultId}
            size={{ xs: 12, sm: 12, md: 6, lg: 4 }}
          >
            <ConsultCard
              consultData={consult}
              assigned={assigned}
              isAssigned={isAssigned}
              pastConsult={pastConsult}
              onAccept={() => onAccept?.(userId ?? 0, consult.consultId)}
            />
          </Grid2>
        ))
      ) : (
        <NoDataMessage message={emptyMessage} />
      )}
    </>
  );
};

export default ConsultListRender;
